import { FC, ReactNode, Suspense } from 'react';

import { Loading } from '@shared/components/Loading';

//* lazy 라우트 청크를 받는 동안의 자리표시자 — 화면 가운데에 공용 스피너
export const RouteFallback: FC = function RouteFallback() {
  return (
    <div role="status" className="center-box min-h-[40vh] w-full">
      <Loading text="불러오는 중" />
    </div>
  );
};

//* lazy 라우트 element는 반드시 이걸로 "라우트마다" 감싼다. <Routes> 전체를 Suspense 하나로 묶으면
//* 청크를 처음 받는 동안 React가 이미 그려진 트리(열린 headlessui Dialog 포함)를 display:none으로 숨기고,
//* Dialog는 "사라짐"을 감지해 onClose(=history.back)를 스스로 불러 방금 push된 목적지가 pop된다
//* (2026-11-02 실사고: 간편구매·답례품 모달에서 첫 클릭이 모달만 닫고 제자리). 정적 가드:
//* src/__adhoc__/lazyRouteSuspense.adhoc.test.tsx
export const lazyRoute = (
  element: ReactNode,
  fallback: ReactNode = <RouteFallback />,
) => <Suspense fallback={fallback}>{element}</Suspense>;
